import { ApplicationConfig } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideMarkdownAnchorOptions, provideMSALAuthentication, provideTranslations } from '@lp/providers';
import { CLIPBOARD_OPTIONS, provideMarkdown } from 'ngx-markdown';
import { ClipboardButtonComponent } from '@lp/components/clipboard-button';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslations(),
    provideMSALAuthentication(),
    provideMarkdown({
      markedOptions: provideMarkdownAnchorOptions(),
      clipboardOptions: {
        provide: CLIPBOARD_OPTIONS,
        useValue: {
          buttonComponent: ClipboardButtonComponent
        }
      }
    })
  ]
};
